export default [
{ label: 'Most Recent', value: 'CREATED_AT DESC' },
{ label: 'Last Modified', value: 'MODIFIED_AT DESC' },
{ label: 'Name: A-Z', value: 'FILE_NAME ASC' },
{ label: 'Name: Z-A', value: 'FILE_NAME DESC' },
{ label: 'Size: Low-High', value: 'FILE_SIZE ASC' },
{ label: 'Size: High-Low', value: 'FILE_SIZE DESC' }];